import { combineReducers } from 'redux';
import auth, { AuthStateT } from './authReducer'

import socket, { SocketStateT } from './socketReducer'

import { TelephonyStateT, telephonyState } from './twilioReducer'
import { filtersJobs, FiltersStateT } from './filtersJobsReducer'
import { REHYDRATE, PURGE, persistCombineReducers } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // or whatever storage you are using



const config = {
  key: 'primary',
  storage
}

export interface IAppState {
  auth: AuthStateT
  filtersJobs: FiltersStateT
  telephonyState: TelephonyStateT
  socket: SocketStateT
}
const reducers = combineReducers<IAppState>({
  // form:formreducer,

  auth,
  filtersJobs,
  //jobs,
  // settings,
  telephonyState,
  //configApp,
  socket,
});

export type RootState = ReturnType<typeof reducers>;
// export default persistCombineReducers(config, reducers);

export default reducers
